import { Shield } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS, NODE_CONFIG_FIELDS } from '../../../constants';
import { WALLETTWO_EVENT_FIELDS } from '../../../constants/fields';
import useAutomationsStore from '../../../../../../store/useAutomationsStore';

const EVENT_LABELS = Object.fromEntries(
  NODE_CONFIG_FIELDS.trigger_wallettwo[0].options.map((o) => [o.value, o.label])
);

export default function WalletTwoEventNode({ id, data, selected }) {
  const { tokens, networks } = useAutomationsStore();
  const eventLabel = data.event ? EVENT_LABELS[data.event] : null;
  const eventFields = data.event ? (WALLETTWO_EVENT_FIELDS[data.event] || []) : [];

  // Build filter pills from configured values
  const pills = [];
  for (const field of eventFields) {
    const val = data[field.key];
    if (!val) continue;

    let display = val;
    if (field.type === 'network_select') {
      const net = networks.find((n) => n.id === val);
      display = net?.name || val;
    } else if (field.type === 'token_select') {
      const tok = tokens.find((t) => t.id === val);
      display = tok ? `${tok.name}${tok.symbol ? ` (${tok.symbol})` : ''}` : val;
    }
    pills.push({ label: field.label, value: display });
  }

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.triggers}
      icon={Shield}
      label={data.label}
      hasInput={false}
    >
      {eventLabel ? (
        <div>
          <span className="inline-block text-[10px] font-medium bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
            {eventLabel}
          </span>
          {pills.length > 0 && (
            <div className="mt-1.5 space-y-1">
              {pills.map((p) => (
                <div key={p.label} className="flex items-center gap-1.5 text-[10px]">
                  <span className="text-gray-400">{p.label}:</span>
                  <span className="font-medium text-gray-600 truncate">{p.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <p className="text-xs text-gray-500">{data.description}</p>
      )}
    </BaseNode>
  );
}
